import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useIsMobile from '../../hooks/useIsMobile';
import useGlobalPrivilegesCta from '../../hooks/useGlobalPrivilegesCta';
import styles from './exclusiveAccessBanner.scss';

const ExclusiveAccessBanner = ({ surface = PowerFunnelSurfaces.HOME, variant = 'exclusive_access' }) => {
    const { isMobileWidth } = useIsMobile();
    const {
        buttonText,
        hasPastDueSubscription,
        pastDueSubscriptionMessage,
        handleCtaClick,
        handleLearnMoreClick,
    } = useGlobalPrivilegesCta({ surface, variant, trackImpressions: true });

    return (
        <div className={styles.exclusiveAccessBanner}>
            <div className={styles.bannerInner}>
                <div className={styles.imageSection}>
                    <img
                        src={isMobileWidth
                            ? '/img/v3/graphics/perks/global-privileges/exclusive-access-mobile.png'
                            : '/img/v3/graphics/perks/global-privileges/exclusive-access.png'}
                        alt="Man relaxing in airport lounge"
                        className={styles.bannerImage}
                    />
                </div>
                <div className={styles.contentSection}>
                    <div className={styles.textGroup}>
                        <p className={styles.headline} data-testid="banners.exclusive-access.headline">
                            Travel like a pro, on and off the court.
                        </p>
                        <p className={styles.body} data-testid="banners.exclusive-access.body">
                            From exclusive discounts on hotels and car rentals, to relaxing
                            in airport lounges, we&apos;ve upgraded your entire travel itinerary.
                        </p>
                    </div>
                    <div className={styles.ctaGroup}>
                        <p className={styles.boldLine} data-testid="banners.exclusive-access.bold-line">
                            Get $250 in travel value instantly.
                        </p>
                        {hasPastDueSubscription && <p className={styles.pastDueMessage} data-testid="banners.exclusive-access.past-due-message">{pastDueSubscriptionMessage}</p>}
                        <button
                            className={styles.ctaButton}
                            onClick={handleCtaClick}
                            type="button"
                            data-testid="banners.exclusive-access.cta-btn"
                        >
                            {buttonText}
                        </button>
                    </div>
                    <div
                        className={styles.learnMore}
                        onClick={handleLearnMoreClick}
                        data-testid="banners.exclusive-access.learn-more"
                    >
                        <span className={styles.underline} data-testid="banners.exclusive-access.learn-more-link">Learn more</span>
                        {' about '}
                        <img
                            src="/img/v3/graphics/perks/global-privileges/global-privileges-logo.png"
                            alt="Global Privileges"
                            className={styles.gpLogo}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ExclusiveAccessBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
    variant: PropTypes.string,
};

ExclusiveAccessBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
    variant: 'exclusive_access',
};

export default ExclusiveAccessBanner;
